import { concatAll, take } from 'rxjs/operators';
import { Router } from "framework7/build/core/modules/router/router";
import { ComponentState } from "../../lib/base-component";
import { BaseListComponent, F7ListComponentContext } from "../../lib/base-list-component";
import { ChatRoom } from "../../lib/nam-chat/chat-room";
import { FileModel } from "../../model/file.model";
import { CommonService } from "../../services/common.service";
import { RootServices } from "../../services/root.services";
import { F7Page } from "../../types/framework7-types";
import { WarehouseGoodsContainerModel, WarehouseGoodsInContainerModel, WarehouseGoodsQueueModel, WarehouseModel } from '../../model/warehouse.model';
import { Template7 } from 'framework7/build/core/framework7.esm';
import { Model } from 'src/app/model/model';
// import * as $ from 'jquery';
declare const $: any;

// declare const $: any;
export interface ComponentStateExtend extends ComponentState {
  [key: string]: any;
  instance?: F7ComponentContextExtend;

  filter?: {
    Type?: string[],
    Warehouse?: string[],
    Parent?: string[],
  };
}

export interface F7ComponentContextExtend extends F7ListComponentContext<WarehouseGoodsContainerModel> {
  responseInProgress?: boolean;
  productList?: WarehouseGoodsContainerModel[];
  $root: any;
  $route: Router.Route & { context?: { backTitle?: string, title?: string, largeTitle?: string, chatRoom?: ChatRoom } };
  warehouseList?: WarehouseModel[],
  parentList?: WarehouseGoodsContainerModel[],
  typeList?: Model[],

}

/** Component group manager */
export class WarehouseGoodsContainerListComponent extends BaseListComponent<ComponentStateExtend, WarehouseGoodsContainerModel> {
  namespace: string = 'warehouse-goods-container-list';

  apiPath = '/warehouse/goods-containers';

  limit = 50;
  title: 'Vị trí hàng hóa'
  chooseMode = false;

  constructor(
    public rootServices: RootServices,
    public commonService: CommonService,
  ) {
    super(rootServices, commonService);
    // // console.log('Click here to open ts file');
  }

  onF7pageRemove(chatRoomId: string) {
    // if (this.chatRoomCacheList[chatRoomId]) {
    //   this.chatRoomCacheList[chatRoomId].disconnect();
    // }
  }

  filterSchema = {
    Type: {
      type: 'smart-select',
      dataType: 'multiple'
    },
    Warehouse: {
      type: 'smart-select',
      dataType: 'multiple'
    },
    Parent: {
      // type: 'smart-select',
      // dataType: 'multiple'

      type: 'autocomplete',
      autocompleteOption: { minSearchInputLength: 0, autoFocus: false, limit: 20 },
      ajax: (query: any) => {
        return this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', {
          filter_Path: query,
          ne_Type: 'DRAWERS',
        }).then(results => {
          return results.map(m => {
            m.id = m.Code;
            m.text = m.Path?.replace(m.WarehouseName + '/', '');
            return m;
          });
        });
      },
      dataType: 'multiple'
    },
  };

  async updateCache(state: ComponentStateExtend) {
    // state.instance.parentList = await this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Type: '[AREA,SHELF,CUPBOARD,FLOOR,LARGE_DRAWERS]', sort_Path: 'asc', onlyIdText: true, limit: 'nolimit' }).then(rs => rs.map(m => ({ id: m.Code, text: m.Path.replace(m.WarehouseName + '/', '') })));
    Promise.all([
      this.rootServices.apiService.getPromise<WarehouseModel[]>('/warehouse/warehouses', { onlyIdText: true, limit: 'nolimit' }).then(rs => rs.map(m => ({ id: m.Code, text: m.Name }))).then(rs => state.instance.warehouseList = rs),
      this.rootServices.apiService.getPromise<Model[]>('/warehouse/goods-containers/types', { includeIdText: true, limit: 'nolimit' }).then(rs => state.instance.typeList = rs),
    ]).then(rs => {
      state.instance.$setState({
        // parentList: state.instance.parentList,
        warehouseList: state.instance.warehouseList,
        typeList: state.instance.typeList,
      });
    });

    return true;
  }

  async onComponentInit(state: ComponentStateExtend, index: string, asCase?: string, f7Page?: F7Page) {
    // const cs = this.state[index];
    this.commonService.showPreloader();

    // Get static data
    await this.updateCache(state);
    // state.instance.warehouseList = await this.rootServices.apiService.getPromise<WarehouseModel[]>('/warehouse/warehouses', { onlyIdText: true, limit: 'nolimit' }).then(rs => rs.map(m => ({ id: m.Code, text: m.Name })));
    // state.instance.parentList = await this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Type: '[AREA,SHELF,CUPBOARD,FLOOR,LARGE_DRAWERS]', sort_Path: 'asc', onlyIdText: true, limit: 'nolimit' }).then(rs => rs.map(m => ({ id: m.Code, text: m.Name })));
    // state.instance.typeList = await this.rootServices.apiService.getPromise<Model[]>('/warehouse/goods-containers/types', { includeIdText: true, limit: 'nolimit' });

    // state.instance.$setState({
    //   warehouseList: state.instance.warehouseList,
    //   parentList: state.instance.parentList,
    //   typeList: state.instance.typeList,
    // });

    state.filter = {
      // Type: ['SHELF'],
    };

    return super.onComponentInit(state, index, asCase, f7Page).then(async currentState => {



      if (f7Page?.route?.context?.barcode) {
        // this.commonService.showPreloader();
        await this.barcodeProcess(f7Page.route.context.barcode).finally(() => {
          // this.commonService.hidePreloader();
        });
      }

      this.commonService.hidePreloader();
      return currentState;
    });
  }

  onItemClick(self: F7ListComponentContext<WarehouseGoodsContainerModel>, item: WarehouseGoodsContainerModel): void {
    return;
  }

  prepareItem(item: WarehouseGoodsContainerModel, index?: number): WarehouseGoodsContainerModel {
    // if (item.UnitConversions && item.UnitConversions.length > 0) {
    //   let defaultSalesUnit = item.UnitConversions.find(f => f.IsDefaultSales);
    //   if (defaultSalesUnit) {
    //     item.Unit = defaultSalesUnit;
    //     const price = item.UnitList && item.UnitList.find(f => f.id === item.Unit.id);
    //     if (price) {
    //       item.Price = price.Price;
    //     }
    //   } else {
    //     defaultSalesUnit = item.UnitConversions[0];
    //     item.Unit = defaultSalesUnit;
    //   }
    // } else {
    //   // item.Unit = item.WarehouseUnit && item.WarehouseUnit.id ? item.WarehouseUnit : (item.WarehouseUnit ? { id: item.WarehouseUnit, text: item.WarehouseUnit } as any : { id: '', text: '--' });
    // }
    // item.global = this.currentState.instance;
    item.isChooseMode = this.currentState.instance.$route?.params?.action == 'choose';
    return item;
  }


  async getList(self?: F7ComponentContextExtend, extParams?: any): Promise<WarehouseGoodsContainerModel[]> {
    if (!this.currentState.isNotFirstLoaded) {
      this.currentState.isNotFirstLoaded = true;
      return [];
    }
    return this.rootServices.apiService.getPromise<any[]>(this.apiPath, {
      priceTable: 'default',
      // includeFeaturePicture: true,
      // includeCategories: true,
      // includeUnits: true,
      // groupByGoods: true,
      // sort_Goods: 'desc',
      // sort_UnitNo: 'asc',
      sort_Path: 'asc',
      ...this.parseFilter(this.currentState?.filter),
      ...extParams,
      ne_State: 'PREPARE_REMOVED',
    }).then(list => {
      self.$setState({ productList: list.map((t, i) => this.prepareItem(t, i)), infiniteLoadLast: list.length === 0 });
      self.infiniteOffset = 10;
      return list;
    }).catch(err => {
      console.error(err);
      this.commonService.showError(err);
      return Promise.reject(err);
    });
  }

  pushToQueueGui(item: WarehouseGoodsContainerModel) {
    const $this = this;
    if (!item.Goods || item.Goods.length == 0) {
      this.commonService.showError('Vị trí không chứa bất kỳ hàng hóa nào !');
      this.commonService.playErrorPipSound();
      return;
    }

    // Enter inventory and order quantity
    const supplierListTemplete = Template7.compile(/*html*/`
      <div class="list media-list" style="margin-left: -1rem; margin-right: -1rem; margin-bottom: 0.5rem; margin-top: 0.5rem; text-align: left; font-size: 1.5rem;">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Tồn kho thực tế</div>
              <div class="item-input-wrap">
                <input class="field text-color-blue" name="Inventory" type="tel" inputmode="numeric" placeholder="Tồn thực tế...">
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Yêu cầu đặt thêm</div>
              <div class="item-input-wrap">
                <input class="field text-color-blue" name="RequestOrderQuantity" type="tel" inputmode="numeric" enterkeyhint="done" placeholder="Yêu cầu đặt thêm...">
              </div>
            </div>
          </li>
        </ul>
      </div>
    `);
    let supplierDialog = null;
    supplierDialog = this.rootServices.f7app.dialog.create({
      cssClass: 'dialog-large',
      title: item.Name,
      text: 'Đẩy vào hàng đợi',
      content: supplierListTemplete({ product: item.Goods[0] }),
      buttons: [
        // ...buttons,
        {
          text: 'Đẩy vào kiểm kho',
          bold: false,
          color: 'orange',
          onClick: async () => {
            const inventory = $(supplierDialog.el).find('[name="Inventory"]').val() as any;
            const requestOrderQuantity = $(supplierDialog.el).find('[name="RequestOrderQuantity"]').val() as any;

            $this.commonService.showPreloader();
            $this.pushToGoodsQueue({
              ...item,
              Inventory: inventory,
              RequestOrderQuantity: requestOrderQuantity,
            }, {
              queue: 'INVENTORYCHECK',
            }).then(() => {
              $this.commonService.hidePreloader();
              $this.commonService.showInfo('Đã đẩy vào hàng đợi kiểm kho');
              $this.commonService.playNewPipSound();
            }).catch(err => {
              $this.commonService.hidePreloader();
              $this.commonService.showError(err);
              $this.commonService.playErrorPipSound();
            });
          },
        },
        {
          text: 'Đẩy vào hết hàng',
          bold: false,
          color: 'red',
          onClick: async () => {
            const inventory = $(supplierDialog.el).find('[name="Inventory"]').val() as any;
            const requestOrderQuantity = $(supplierDialog.el).find('[name="RequestOrderQuantity"]').val() as any;

            $this.commonService.showPreloader();
            $this.pushToGoodsQueue({
              ...item,
              Inventory: inventory,
              RequestOrderQuantity: requestOrderQuantity,
            }, {
              queue: 'OUTOFSTOCK',
            }).then(() => {
              $this.commonService.hidePreloader();
              $this.commonService.showInfo('Đã đẩy vào hàng đợi hết hàng');
              $this.commonService.playNewPipSound();
            }).catch(err => {
              $this.commonService.hidePreloader();
              $this.commonService.showError(err);
              $this.commonService.playErrorPipSound();
            });
          },
        },
        {
          text: 'Trở về',
          bold: true,
          color: 'gray'
        },
      ],
      verticalButtons: true,
    });
    supplierDialog.open();

    // Enter to action
    $(supplierDialog.$el).find('input[name="RequestOrderQuantity"]').keydown(e => {
      console.log('enter to action', e);
      if (e.key == 'Enter') {
        const inventory = $(supplierDialog.el).find('[name="Inventory"]').val() as any;
        const requestOrderQuantity = $(supplierDialog.el).find('[name="RequestOrderQuantity"]').val() as any;

        supplierDialog.close();
        $this.commonService.showPreloader();
        $this.pushToGoodsQueue({
          ...item,
          Inventory: inventory,
          RequestOrderQuantity: requestOrderQuantity,
        }).then(() => {
          $this.commonService.hidePreloader();
          $this.commonService.showInfo('Đã đẩy vào hàng đợi');
          $this.commonService.playNewPipSound();
        }).catch(err => {
          $this.commonService.hidePreloader();
          $this.commonService.showError(err);
          $this.commonService.playErrorPipSound();
        });
      }
    });
  }

  pushToQueueInTemCaseGui(item: WarehouseGoodsContainerModel) {
    const $this = this;
    if (!item.Goods || item.Goods.length == 0) {
      this.commonService.showError('Vị trí không chứa bất kỳ hàng hóa nào !');
      this.commonService.playErrorPipSound();
      return;
    }

    // Enter inventory and order quantity
    const supplierListTemplete = Template7.compile(/*html*/`
      <div class="list media-list" style="margin-left: -1rem; margin-right: -1rem; margin-bottom: 0.5rem; margin-top: 0.5rem; text-align: left; font-size: 1.5rem;">
        <ul>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Tồn kho thực tế (in tem)</div>
              <div class="item-input-wrap">
                <input class="field text-color-blue" name="Inventory" type="tel" inputmode="numeric" placeholder="Số tem muốn in...">
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">yêu cầu đặt thêm</div>
              <div class="item-input-wrap">
                <input class="field text-color-blue" name="RequestOrderQuantity" type="tel" inputmode="numeric" enterkeyhint="done" placeholder="Yêu cầu đặt thêm...">
              </div>
            </div>
          </li>
        </ul>
      </div>
    `);
    let supplierDialog = null;
    supplierDialog = this.rootServices.f7app.dialog.create({
      cssClass: 'dialog-large',
      title: item.Name,
      text: 'Đẩy vào hàng đợi in tem',
      content: supplierListTemplete({ product: item.Goods[0] }),
      buttons: [
        // ...buttons,
        {
          text: 'Đẩy vào hàng đợi',
          bold: false,
          color: 'blue',
          onClick: async () => {
            const inventory = $(supplierDialog.el).find('[name="Inventory"]').val() as any;
            const requestOrderQuantity = $(supplierDialog.el).find('[name="RequestOrderQuantity"]').val() as any;

            $this.commonService.showPreloader();
            $this.pushToGoodsQueue({
              ...item,
              Inventory: inventory,
              RequestOrderQuantity: requestOrderQuantity,
            }, {
              queue: 'TEMPRINT',
            }).then(() => {
              $this.commonService.hidePreloader();
              $this.commonService.showInfo('Đã đẩy vào hàng đợi');
              $this.commonService.playNewPipSound();
            }).catch(err => {
              $this.commonService.hidePreloader();
              $this.commonService.showError(err);
              $this.commonService.playErrorPipSound();
            });
          },
        },
        {
          text: 'Trở về',
          bold: true,
          color: 'red'
        },
      ],
      verticalButtons: true,
    });
    supplierDialog.open();

    // Enter to action
    $(supplierDialog.$el).find('input[name="RequestOrderQuantity"]').keydown(e => {
      console.log('enter to action', e);
      if (e.key == 'Enter') {
        const inventory = $(supplierDialog.el).find('[name="Inventory"]').val() as any;
        const requestOrderQuantity = $(supplierDialog.el).find('[name="RequestOrderQuantity"]').val() as any;

        supplierDialog.close();
        $this.commonService.showPreloader();
        $this.pushToGoodsQueue({
          ...item,
          Inventory: inventory,
          RequestOrderQuantity: requestOrderQuantity,
        }, {
          queue: 'TEMPRINT',
        }).then(() => {
          $this.commonService.hidePreloader();
          $this.commonService.showInfo('Đã đẩy vào hàng đợi');
          $this.commonService.playNewPipSound();
        }).catch(err => {
          $this.commonService.hidePreloader();
          $this.commonService.showError(err);
          $this.commonService.playErrorPipSound();
        });
      }
    });
  }

  itemBeforeInsert(element: HTMLElement, item: WarehouseGoodsInContainerModel): void {
    const $this = this;
    $(element).find('.chooseBtn').unbind('click').click(() => {
      this.currentState.instance.$route.context['onChoose'] && this.currentState.instance.$route.context['onChoose'](item);
    });
    $(element).find('.pushToQueueInTemCase').unbind('click').click(() => {
      $this.pushToQueueInTemCaseGui(item);
    });
    $(element).find('.pushToQueue').unbind('click').click(() => {
      $this.pushToQueueGui(item);
      // if (!item.Goods || item.Goods.length == 0) {
      //   this.commonService.showError('Vị trí không chứa bất kỳ hàng hóa nào !');
      //   this.commonService.playErrorPipSound();
      //   return;
      // }

      // // Enter inventory and order quantity
      // const supplierListTemplete = Template7.compile(/*html*/`
      //   <div class="list media-list" style="margin-left: -1rem; margin-right: -1rem; margin-bottom: 0.5rem; margin-top: 0.5rem; text-align: left; font-size: 1.5rem;">
      //     <ul>
      //       <li class="item-content item-input">
      //         <div class="item-inner">
      //           <div class="item-title item-label">Tồn kho thực tế</div>
      //           <div class="item-input-wrap">
      //             <input class="field text-color-blue" name="Inventory" type="tel" inputmode="numeric" placeholder="Tồn thực tế...">
      //           </div>
      //         </div>
      //       </li>
      //       <li class="item-content item-input">
      //         <div class="item-inner">
      //           <div class="item-title item-label">Yêu cầu đặt thêm</div>
      //           <div class="item-input-wrap">
      //             <input class="field text-color-blue" name="RequestOrderQuantity" type="tel" inputmode="numeric" enterkeyhint="done" placeholder="Yêu cầu đặt thêm...">
      //           </div>
      //         </div>
      //       </li>
      //     </ul>
      //   </div>
      // `);
      // let supplierDialog = null;
      // supplierDialog = this.rootServices.f7app.dialog.create({
      //   cssClass: 'dialog-large',
      //   title: item.Name,
      //   text: 'Đẩy vào hàng đợi',
      //   content: supplierListTemplete({ product: item.Goods[0] }),
      //   buttons: [
      //     // ...buttons,
      //     {
      //       text: 'Đẩy vào hàng đợi',
      //       bold: false,
      //       color: 'blue',
      //       onClick: async () => {
      //         const inventory = $(supplierDialog.el).find('[name="Inventory"]').val() as any;
      //         const requestOrderQuantity = $(supplierDialog.el).find('[name="RequestOrderQuantity"]').val() as any;

      //         $this.commonService.showPreloader();
      //         $this.pushToGoodsQueue({
      //           ...item,
      //           Inventory: inventory,
      //           RequestOrderQuantity: requestOrderQuantity,
      //         }).then(() => {
      //           $this.commonService.hidePreloader();
      //           $this.commonService.showInfo('Đã đẩy vào hàng đợi');
      //           $this.commonService.playNewPipSound();
      //         }).catch(err => {
      //           $this.commonService.hidePreloader();
      //           $this.commonService.showError(err);
      //           $this.commonService.playErrorPipSound();
      //         });
      //       },
      //     },
      //     {
      //       text: 'Trở về',
      //       bold: true,
      //       color: 'red'
      //     },
      //   ],
      //   verticalButtons: true,
      // });
      // supplierDialog.open();

      // // Enter to action
      // $(supplierDialog.$el).find('input[name="RequestOrderQuantity"]').keydown(e => {
      //   console.log('enter to action', e);
      //   if (e.key == 'Enter') {
      //     const inventory = $(supplierDialog.el).find('[name="Inventory"]').val() as any;
      //     const requestOrderQuantity = $(supplierDialog.el).find('[name="RequestOrderQuantity"]').val() as any;

      //     supplierDialog.close();
      //     $this.commonService.showPreloader();
      //     $this.pushToGoodsQueue({
      //       ...item,
      //       Inventory: inventory,
      //       RequestOrderQuantity: requestOrderQuantity,
      //     }).then(() => {
      //       $this.commonService.hidePreloader();
      //       $this.commonService.showInfo('Đã đẩy vào hàng đợi');
      //       $this.commonService.playNewPipSound();
      //     }).catch(err => {
      //       $this.commonService.hidePreloader();
      //       $this.commonService.showError(err);
      //       $this.commonService.playErrorPipSound();
      //     });
      //   }
      // });

    });
    $(element).find('.openProduct').unbind('click').click(() => {
      this.rootServices.navigate('/admin-product/product/' + item.Goods, {
        context: {
          backTitle: this.title,
          textColorClass: this.currentState.instance.textColorClass,
          callback: (data: { case: string, product: WarehouseGoodsContainerModel }) => {
            console.log(data);
            this.refresh(this.currentState.instance);
          }
        }
      });
    });
    $(element).find('.duplicateBtn').unbind('click').click(() => {
      this.rootServices.navigate('/warehouse/goods-container-form/new', {
        context: {
          copyFromId: item.Code,
          backTitle: this.title,
          textColorClass: this.currentState.instance.textColorClass,
          callback: (data: { case: string, product: WarehouseGoodsContainerModel }) => {
            console.log(data);
            this.refresh(this.currentState.instance);
            $this.updateCache($this.currentState);
          }
        }
      });
    });
    $(element).find('.editBtn').unbind('click').click(() => {
      this.rootServices.navigate('/warehouse/goods-container-form/' + item.Code, {
        context: {
          backTitle: this.title,
          textColorClass: this.currentState.instance.textColorClass,
          callback: (data: { case: string, product: WarehouseGoodsContainerModel }) => {
            console.log(data);
            this.refresh(this.currentState.instance);
            $this.updateCache($this.currentState);
          }
        }
      });
    });
    $(element).find('.previewPictures').unbind('click').click(async () => {
      // const product = await this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/admin-product/products/' + item.Goods).then(rs => rs[0]);
      this.previewPictures(item.GoodsImages, 0);
    });

    $(element).find('.unitBtn').unbind('click').click(async function () {

      const unitId = $(this).attr('data-unit');
      if (item.Units && item.Units.length > 0) {
        const unit = item.Units.find(u => u.id == unitId);
        if (unit) {
          if (unit.NumOfContainer > 0) {

            const containers = await $this.rootServices.apiService.getPromise<WarehouseGoodsInContainerModel[]>($this.apiPath, { eq_Goods: item.Goods, eq_Unit: unitId }).then(rs => rs.map(container => ({
              id: container.Container,
              text: container.ContainerShelfName + '/' + container.ContainerFindOrder,
              Shelf: container.ContainerShelf,
              ShelfName: container.ContainerShelfName,
              FindOrder: container.ContainerFindOrder,
              Inventory: container.Inventory,
              Unit: {
                id: container.Unit,
                text: container.UnitLabel,
              }
            })));

            let listItemTemplate = Template7.compile(/*html*/`
            <div class="list" style="margin-left: -1rem; margin-right: -1rem; margin-bottom: 0">
              <ul>
                {{#each containers}}
                <li data-container="{{id this}}">
                  <a href="#" class="item-link item-content">
                    <!--<div class="item-media"><i class="icon icon-f7"></i></div>-->
                    <div class="item-inner">
                      <div class="item-title">{{text this}}</div>
                      <div class="item-after">{{decimal Inventory}} {{text Unit}}</div>
                    </div>
                  </a>
                </li>
                {{/each}}
              </ul>
            </div>
            `);

            const dialog = $this.currentState.instance.$app.dialog.create({
              title: $this.isChooseMode ? 'Chọn vị trí' : 'Vị trí hàng hóa',
              text: ($this.isChooseMode ? 'Chọn theo vị trí của ' : 'Hiển thị barcode cho ') + item.GoodsName + ' (' + item.UnitLabel + ')"',
              content: listItemTemplate({ containers }),
              buttons: [
                {
                  text: 'Trở về',
                  bold: true,
                  color: 'red'
                },
              ],
              verticalButtons: true,
            });
            dialog.open();

            // const listEle = dialog.$el.find('.list');
            const listItem = dialog.$el.find('.list li');
            listItem.click(function () {
              const containerId = $(this).attr('data-container');
              const container = containers.find(c => c.id == containerId);

              if ($this.isChooseMode) {
                $this.currentState.instance.$route.context['onChoose'] && $this.currentState.instance.$route.context['onChoose']({
                  ...item,
                  Unit: unit,
                  Container: container,
                })
              } else {

                $this.currentState.instance.$app.dialog.create({
                  // title: $this.isChooseMode ? 'Chọn vị trí' : 'Barcode',
                  // text: ($this.isChooseMode ? 'Chọn theo vị trí của ' : 'Hiển thị barcode cho ') + item.GoodsName + ' (' + item.UnitLabel + ')"',
                  title: 'Hành động',
                  text: item.GoodsName + ' (' + item.UnitLabel + ') - ' + $this.commonService.getObjectText(container),
                  buttons: [
                    {
                      text: 'Hiển thị barcode',
                      color: 'blue',
                      onClick: () => {
                        $this.rootServices.apiService.getPromise<any[]>('/warehouse/find-order-tems', {
                          id0: `${item.Goods}-${item.Unit}-${containerId}`,
                          includeWarehouse: true,
                          renderBarCode: true,
                          masterPriceTable: 'default',
                          includeGroups: true,
                          includeUnit: true,
                          includeFeaturePicture: true,
                          group_Unit: true,
                          includeContainers: true,
                          limit: 'nolimit',
                        }).then(rs2 => {
                          console.log(rs2);
                          if (rs2 && rs2.length > 0) {
                            $this.commonService.hidePreloader();
                            $this.currentState.instance.$app.photoBrowser.create({
                              photos: rs2.map((m, index) => {

                                return {
                                  caption: $this.commonService.getObjectText(item.GoodsSku + ' - ' + item.GoodsName + ' (' + item.Goods + ') ' + ' - ' + item.ContainerShelfName + '/' + item.ContainerFindOrder),
                                  html: `<div style="background: #fff"><img src="${m.BarCode}"</div>`
                                };

                              }),
                              theme: 'light',
                              type: 'standalone' as any,
                            }).open();
                          } else {
                            $this.commonService.showError('Không thể tạo barcode cho hàng hóa này');
                          }
                        }).catch(err => {
                          $this.commonService.hidePreloader();
                        });
                      }
                    },
                    {
                      text: 'Cho vào hàng đợi',
                      color: 'blue',
                      onClick: () => {
                        $this.pushToGoodsQueue({
                          ...item,
                          Unit: $this.commonService.getObjectId(unit),
                          UnitLabel: $this.commonService.getObjectText(unit),
                          Container: $this.commonService.getObjectId(container),
                          ContainerShelf: container.Shelf,
                          ContainerShelfName: container.ShelfName,
                          ContainerFindOrder: container.FindOrder,
                          Inventory: container.Inventory,
                        }).then(rs => {
                          $this.commonService.showInfo('Đã đẩy hàng hóa và hàng đợi.', { position: 'center' });
                        });
                      }
                    },
                    {
                      text: 'Trở về',
                      bold: true,
                      color: 'red'
                    },
                  ],
                  verticalButtons: true,
                }).open();
              }
              dialog.close();
              // dialog.destroy();
            });
          }
        }
      }


    });
    $(element).find('.showBarcode').unbind('click').click(() => {
      $this.commonService.showPreloader();
      $this.rootServices.apiService.getPromise<any[]>('/warehouse/find-order-tems', {
        id0: `${item.Goods}-${item.Unit}-${item.Container}`,
        includeWarehouse: true,
        renderBarCode: true,
        masterPriceTable: 'default',
        includeGroups: true,
        includeUnit: true,
        includeFeaturePicture: true,
        group_Unit: true,
        includeContainers: true,
        limit: 'nolimit',
      }).then(rs2 => {
        console.log(rs2);
        if (rs2 && rs2.length > 0) {
          $this.commonService.hidePreloader();
          $this.currentState.instance.$app.photoBrowser.create({
            photos: rs2.map((m, index) => {

              return {
                caption: $this.commonService.getObjectText(item.GoodsSku + ' - ' + item.GoodsName + ' (' + item.Goods + ') ' + ' - ' + item.ContainerShelfName + '/' + item.ContainerFindOrder),
                html: `<div style="background: #fff"><img src="${m.BarCode}"</div>`
              };

            }),
            theme: 'light',
            type: 'standalone' as any,
          }).open();
        } else {
          $this.commonService.showError('Không thể tạo barcode cho hàng hóa này');
        }
      }).catch(err => {
        $this.commonService.hidePreloader();
      });
    });

    $(element).find('.moreBtn').unbind('click').click(async function () {
      $this.currentState.instance.$app.dialog.create({
        title: 'Hành động',
        content: item.Name,
        verticalButtons: true,
        buttons: [
          {
            text: 'Không sử dụng',
            color: 'red',
            bold: false,
            onClick: () => {
              $this.commonService.showPreloader();
              $this.rootServices.apiService.putPromise<WarehouseGoodsContainerModel[]>($this.apiPath, { changeState: 'PREPARE_REMOVED' }, [{ Code: item.Code, State: 'PREPARE_REMOVED' }]).then(rs => {
                $this.commonService.hidePreloader();
                $this.refresh();
              }).catch(err => {
                $this.commonService.hidePreloader();
                console.error(err);
              });
            },
          },
          {
            text: 'Chuyển chổ',
            color: 'blue',
            bold: false,
            onClick: () => {
              $this.rootServices.navigate('/warehouse/goods-container-form/' + item.Code, {
                context: {
                  backTitle: $this.title,
                  textColorClass: $this.currentState.instance.textColorClass,
                  callback: (data: { case: string, product: WarehouseGoodsContainerModel }) => {
                    console.log(data);
                    $this.refresh($this.currentState.instance);
                    $this.updateCache($this.currentState);
                  }
                }
              });
            },
          },
          {
            text: 'Trở về',
            color: 'gray',
            bold: false,
            onClick: () => {

            },
          },
        ],
      }).open();
    });

    return;
  }

  async pushToGoodsQueue(goodsContainer: WarehouseGoodsInContainerModel, option?: { queue?: string, inCase?: string }) {
    const goods = goodsContainer.Goods && goodsContainer.Goods[0] || null;
    if (!goods) {
      this.commonService.showError('Không có hàng hóa nào taik vị trí này');
      return Promise.reject('Không có hàng hóa nào taik vị trí này');
    }
    // const product = await this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/admin-product/products/' + this.commonService.getObjectId(goods)).then(rs => rs[0]);
    // if (!product) {
    //   this.commonService.showError('Hàng hóa không tồn tại');
    //   return Promise.reject('Hàng hóa không tồn tại');
    // }
    return this.rootServices.apiService.postPromise<WarehouseGoodsQueueModel[]>('/warehouse/goods-queues', {}, [{
      Goods: this.commonService.getObjectId(goods),
      Unit: goods.Unit,
      UnitLabel: goods.UnitLabel || this.commonService.getObjectText(goods.Unit),
      Name: goods.Name,
      Sku: goods.Sku,
      Queue: option?.queue || 'OUTOFSTOCK',
      InCase: option?.inCase || goodsContainer.InCase,
      Thumbnail: goods.FeaturePicture,
      Pictures: goods.Pictures,
      Container: goodsContainer.Code,
      ContainerShelf: this.commonService.getObjectId(goodsContainer.ContainerShelf),
      ContainerShelfName: goodsContainer.ContainerShelfName,
      ContainerFindOrder: goodsContainer.ContainerFindOrder,
      Inventory: goodsContainer.Inventory,
      RequestOrderQuantity: goodsContainer.RequestOrderQuantity,
    }]).catch(err => {
      this.commonService.showError(err);
      return Promise.reject(err);
    }).then(rs => rs[0]);
  }

  async onFilterFieldChange(self: F7ComponentContextExtend, e: any) {
    return super.onFilterFieldChange(self, e);
  }

  async barcodeProcess(barcode: string) {
    const $this = this;
    // let barcode = barcodeData?.text;
    try {
      if (barcode) {
        // this.commonService.showInfo(barcode);
        // get container info

        let containerId = barcode;
        let findOrder = '';
        let containerInfo: WarehouseGoodsContainerModel = null;

        this.commonService.showPreloader();

        try {

          if (/^9\d+/.test(barcode)) {
            const { product, unit, container, findOrder, price, accessNumber, unitSeq } = await this.rootServices.barcodeExtract(barcode);
            if (product && unit && container) {
              containerId = this.commonService.getObjectId(container);
            }
          }
          if (/^F\d+/.test(containerId)) {
            findOrder = containerId.substring(1);
          }
          if (findOrder) {
            containerInfo = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_FindOrder: findOrder }).then(rs => rs[0]);
          } else {
            containerInfo = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers/' + containerId).then(rs => rs[0]);
          }
          console.log(containerInfo);

          if (this.commonService.getObjectId(containerInfo.Type) == 'DRAWERS') {
            // $this.pushToQueueGui(containerInfo);
            $this.setSearchBarQuery(containerInfo.Code);
            await $this.setFilter({
              Type: ['DRAWERS'],
              Parent: [this.commonService.getObjectId(containerInfo.Parent)],
              Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
            }).then(() => {
              return $this.refresh();
            });
          } else {
            this.currentState.instance.searchBar.disable();
            if (this.commonService.getObjectId(containerInfo.Type) == 'FLOOR') {
              const largeDrawers = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Parent: containerInfo.Code, eq_Type: '[LARGE_DRAWERS]' });
              const parents = largeDrawers.map(m => m.Code);
              parents.push(containerInfo.Code);
              await $this.setFilter({
                Type: ['DRAWERS'],
                Parent: parents,
                Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
              }).then(() => {
                return $this.refresh();
              });
            } else if (this.commonService.getObjectId(containerInfo.Type) == 'SHELF') {
              const floors = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Parent: containerInfo.Code, eq_Type: 'FLOOR' });
              const largeDrawers = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Parent: '[' + floors.map(m => m.Code).join(',') + ']', eq_Type: 'LARGE_DRAWERS' });
              const parents = largeDrawers.map(m => m.Code);
              floors.map(m => parents.push(m.Code));
              parents.push(containerInfo.Code);
              await $this.setFilter({
                Type: ['DRAWERS'],
                Parent: parents,
                Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
              }).then(() => {
                return $this.refresh();
              });
            } else {
              await $this.setFilter({
                Type: ['DRAWERS'],
                Parent: [containerInfo.Code],
                Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
              }).then(() => {
                return $this.refresh();
              });
            }
          }
          this.commonService.hidePreloader();
        } catch (err) {
          this.commonService.hidePreloader();
        }

        // filter as parent and type is DRAWERS


      }
    } catch (err) {
      $this.commonService.showError(err);
      $this.commonService.hidePreloader();
    }
  }

  scan2ContainerCode() {
    const $this = this;
    this.rootServices.scanBarcodeByMlKit().then(async barcodeData => {
      let barcode = barcodeData?.text;
      try {
        if (barcode) {
          // this.commonService.showInfo(barcode);
          // get container info

          await $this.barcodeProcess(barcode);
        }

        //   let containerId = barcode;
        //   let findOrder = '';
        //   let containerInfo: WarehouseGoodsContainerModel = null;

        //   this.commonService.showPreloader();

        //   try {

        //     if (/^9\d+/.test(barcode)) {
        //       const { product, unit, container, findOrder, price, accessNumber, unitSeq } = await this.rootServices.barcodeExtract(barcode);
        //       if (product && unit && container) {
        //         containerId = this.commonService.getObjectId(container);
        //       }
        //     }
        //     if(/^F\d+/.test(containerId)) {
        //       findOrder = containerId.substring(1);
        //     }
        //     if(findOrder) {
        //       containerInfo = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_FindOrder: findOrder }).then(rs => rs[0]);
        //     } else {
        //       containerInfo = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers/' + containerId).then(rs => rs[0]);
        //     }
        //     console.log(containerInfo);

        //     if (this.commonService.getObjectId(containerInfo.Type) == 'DRAWERS') {
        //       // $this.pushToQueueGui(containerInfo);
        //       $this.setSearchBarQuery(containerInfo.Code);
        //       await $this.setFilter({
        //         Type: ['DRAWERS'],
        //         Parent: [this.commonService.getObjectId(containerInfo.Parent)],
        //         Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
        //       }).then(() => {
        //         return $this.refresh();
        //       });
        //     } else {
        //       this.currentState.instance.searchBar.disable();
        //       if (this.commonService.getObjectId(containerInfo.Type) == 'FLOOR') {
        //         const largeDrawers = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Parent: containerInfo.Code, eq_Type: '[LARGE_DRAWERS]' });
        //         const parents = largeDrawers.map(m => m.Code);
        //         parents.push(containerInfo.Code);
        //         await $this.setFilter({
        //           Type: ['DRAWERS'],
        //           Parent: parents,
        //           Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
        //         }).then(() => {
        //           return $this.refresh();
        //         });
        //       } else if (this.commonService.getObjectId(containerInfo.Type) == 'SHELF') {
        //         const floors = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Parent: containerInfo.Code, eq_Type: 'FLOOR' });
        //         const largeDrawers = await $this.rootServices.apiService.getPromise<WarehouseGoodsContainerModel[]>('/warehouse/goods-containers', { eq_Parent: '[' + floors.map(m => m.Code).join(',') + ']', eq_Type: 'LARGE_DRAWERS' });
        //         const parents = largeDrawers.map(m => m.Code);
        //         floors.map(m => parents.push(m.Code));
        //         parents.push(containerInfo.Code);
        //         await $this.setFilter({
        //           Type: ['DRAWERS'],
        //           Parent: parents,
        //           Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
        //         }).then(() => {
        //           return $this.refresh();
        //         });
        //       } else {
        //         await $this.setFilter({
        //           Type: ['DRAWERS'],
        //           Parent: [containerInfo.Code],
        //           Warehouse: [$this.commonService.getObjectId(containerInfo.Warehouse)]
        //         }).then(() => {
        //           return $this.refresh();
        //         });
        //       }
        //     }
        //     this.commonService.hidePreloader();
        //   } catch (err) {
        //     this.commonService.hidePreloader();
        //   }

        //   // filter as parent and type is DRAWERS


        // }
      } catch (err) {
        $this.commonService.showError(err);
        $this.commonService.hidePreloader();
      }
    });
  }


  itemHeight = 208;
  itemTemplate = /*html*/`
  <li class="swipeout block block-strong inset list-item index-{{@index}}" data-id="{{Code}}" data-index="{{@index}}" style="height: 197px; overflow: hidden; margin-top: 0; margin-bottom: 10px">
    <div class="item-content swipeout-content">
      <div class="detail-wrap">
        <div class="detail-header">
          <div class="header-label">[{{FindOrder}}] {{Name}}</div>
          {{#js_if "this.isChooseMode"}}
          <div class="detail-choose chooseBtn link"><i class="icon f7-icons color-orange" style="font-size: 2rem;">checkmark_alt_circle_fill</i></div>
          {{else}}
          <div class="detail-choose editBtn link"><i class="icon f7-icons color-orange" style="font-size: 2rem;">pencil_circle_fill</i></div>
          {{/js_if}}
        </div>
        <div class="detail-body">
          <div class="image-wrap" style="padding-bottom: 0.5rem">
            <div class="image previewPictures" data-index="0" style="height: 112px; {{js "this.GoodsImages && this.GoodsImages[0] && this.GoodsImages[0].Thumbnail && ('background-image: url('+this.GoodsImages[0].Thumbnail+')') || ''"}}"></div>
          </div>
          <div class="detail-content-wrap">
            {{#js_if "(this.Type && this.Type.id || this.Type) == 'DRAWERS'"}}
            <div class="list inline-labels no-hairlines thin-scrollbar" style="overflow: auto; max-height: 128px;">
              <ul>
                {{#each Goods}}
                <li class="item-content item-input unitBtn" data-unit="{{id}}"  style="padding-left: 0; min-height: 2rem;">
                  <div class="item-inner">
                    <div class="item-title item-label">IDSP</div>
                    <div class="unit text-color-blue item-after" style="text-align: right">
                    {{Code}}
                    </div>
                  </div>
                </li>
                <li class="item-content item-input unitBtn" data-unit="{{id}}"  style="padding-left: 0; min-height: 2rem;">
                  <div class="item-inner">
                    <div class="item-title item-label">Sku</div>
                    <div class="unit text-color-blue item-after" style="text-align: right">
                    {{Sku}}
                    </div>
                  </div>
                </li>
                <li class="item-content item-input unitBtn" data-unit="{{id}}"  style="padding-left: 0; min-height: 2rem;">
                  <div class="item-inner">
                    <div class="item-title item-label">Tồn kho</div>
                    <div class="unit text-color-blue item-after" style="text-align: right">
                      {{decimal Inventory}} {{text Unit}}
                    </div>
                  </div>
                </li>
                {{/each}}
              </ul>
            </div>
            {{else}}
            <div class="list inline-labels no-hairlines thin-scrollbar" style="overflow: auto; max-height: 128px;">
              <li class="item-content item-input unitBtn" data-unit="{{id}}"  style="padding-left: 0; min-height: 2rem;">
                <div class="item-inner">
                  <div class="item-title item-label">Loại</div>
                  <div class="unit text-color-blue item-after" style="text-align: right">
                  {{text Type}}
                  </div>
                </div>
              </li>
              <li class="item-content item-input unitBtn" data-unit="{{id}}"  style="padding-left: 0; min-height: 2rem;">
                <div class="item-inner">
                  <div class="item-title item-label">ID vị trí</div>
                  <div class="unit text-color-blue item-after" style="text-align: right">
                  {{text Code}}
                  </div>
                </div>
              </li>
              <li class="item-content item-input unitBtn" data-unit="{{id}}"  style="padding-left: 0; min-height: 2rem;">
                <div class="item-inner">
                  <div class="item-title item-label">Số nhận thức</div>
                  <div class="unit text-color-blue item-after" style="text-align: right">
                  {{text FindOrder}}
                  </div>
                </div>
              </li>
            </div>
            {{/js_if}}
          </div>
        </div>
        <div class="detail-footer">{{text Path}}</div>
      </div>
    </div>
    <div class="swipeout-actions-right">
      <a href="#" class="moreBtn open-more-actions swipeout-close color-gray">more</a>
      {{#js_if "(this.Type && this.Type.id || this.Type) != 'DRAWERS'"}}
      <a href="#" class="duplicateBtn open-more-actions swipeout-close color-blue">copy</a>
      {{/js_if}}
      {{#js_if "this.Goods && this.Goods.length > 0"}}
      <a href="#" class="pushToQueueInTemCase open-more-actions swipeout-close color-orange">in tem</a>
      <a href="#" class="pushToQueue open-more-actions swipeout-close swipeout-overswipe color-red">hàng đợi</a>
      {{/js_if}}
    </div>
  </li>
  `;

  get f7Component(): Router.RouteParameters {
    const $this = this;
    return {
      name: this.namespace,
      path: '/warehouse/goods-container-list',
      component: {
        template: /*html*/`
            <div class="page page-${this.namespace} no-toolbar-x" data-name="page-${this.namespace}">
              <div class="navbar">
                <div class="navbar-bg"></div>
                <div class="navbar-inner sliding">
                  <div class="left">
                    <a class="link back {{textColorClass}}">
                      <i class="icon icon-back"></i>
                      <span class="if-not-md {{textColorClass}}">{{backTitle}}</span>
                    </a>
                  </div>
                  <div class="title">Vị trí hàng hoá</div>
                  <div class="right">
                    <!-- Link to enable searchbar -->
                    <a class="link icon-only searchbar-enable {{textColorClass}}" data-searchbar=".${this.namespace}-searchbar">
                      <i class="icon f7-icons if-not-md">search</i>
                      <i class="icon material-icons md-only">search</i>
                    </a>
                  </div>
                  <!-- Searchbar is a direct child of "navbar-inner" -->
                  <form class="searchbar ${this.namespace}-searchbar searchbar-expandable">
                    <div class="searchbar-inner">
                      <div class="searchbar-input-wrap">
                        <input type="search" placeholder="Search" />
                        <i class="searchbar-icon"></i><span class="input-clear-button"></span>
                        
                      </div>
                      <span class="searchbar-disable-button {{textColorClass}}">Hủy</span>
                    </div>
                  </form>
                </div>
              </div>
              <div class="page-content ptr-content infinite-scroll-content" @ptr:refresh="refresh">
                <div class="ptr-preloader">
                  <div class="preloader"></div>
                  <div class="ptr-arrow"></div>
                </div>
                <div class="searchbar-backdrop ${this.namespace}-backdrop"></div>

                <div class="block-title" style="margin-top: 2rem">Bộ lọc <a style="float: right" @click="resetFilter"
                class="text-color-red">đặt lại</a></div>
                <div class="block block-strong inset filter" style="padding: 0; overflow: hidden">
                  <div class="list accordion-list inline-labels no-hairlines" style="margin: 0;">
                    <ul>
                      <li>
                        <a class="item-link smart-select smart-select-init" name="Type" data-open-in="popup" data-searchbar="true" data-virtual-list="true" data-close-on-select="true" data-popup-swipe-to-close="true" data-scroll-yo-selected-item="true" @smartselect:close="onFilterFieldChange">
                            <select multiple>
                              <option value="">Chọn</option>
                              {{#each typeList}}
                              <option value="{{id}}">{{text}}</option>
                              {{/each}}
                            </select>
                            <div class="item-content">
                              <div class="item-inner">
                                <div class="item-title">Loại</div>
                              </div>
                            </div>
                          </a>
                      </li>
                      <li>
                        <a class="item-link smart-select smart-select-init" name="Warehouse" data-open-in="popup" data-searchbar="true" data-virtual-list="true" data-close-on-select="true" data-popup-swipe-to-close="true" data-scroll-yo-selected-item="true" @smartselect:close="onFilterFieldChange">
                            <select multiple>
                              <option value="">Chọn</option>
                              {{#each warehouseList}}
                              <option value="{{id}}">{{text}}</option>
                              {{/each}}
                            </select>
                            <div class="item-content">
                              <div class="item-inner">
                                <div class="item-title">Kho bãi</div>
                              </div>
                            </div>
                          </a>
                      </li>
                      <li class="autocomplete" name="Parent">
                        <div class="item-link smart-select item-content" href="#">
                          <div class="item-inner" style="display: flex;">
                            <div class="item-title">Vị trí</div>
                            <div class="item-after">{{text filter.Parent 'Chọn vị trí...'}}</div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="block">
                  <div class="row">
                    <a class="col-100 button button-fill button-large color-green" @click="scan2ContainerCode"><i class="icon f7-icons if-not-md-x">qrcode_viewfinder</i> Quét mã vị trí</a>
                  </div>
                </div>

                <div class="block block-strong inset">
                  <i>Kéo sang trái để đẩy vào hàng đợi</i>
                  {{#js_if "this.barcode"}}
                  <br>
                  <i>kết quả liên quan tới vị trí: {{barcode}}</i>
                  {{/js_if}}
                </div>
            
                <div class="block-title">Vị trí hàng hóa <a style="float: right" @click="createNewContainer"
                    class="{{textColorClass}}">+ thêm</a></div>
                <div class="virtual-list ${this.namespace}-virtual-list thumbnail-list"></div>


                {{#if infiniteLoadLast}}
                <div style="text-align: center" class="text-color-gray">end</div>
                {{else}}
                <div class="preloader color-blue infinite-scroll-preloader">
                    <span class="preloader-inner">
                        <span class="preloader-inner-line"></span><span class="preloader-inner-line"></span><span
                            class="preloader-inner-line"></span><span class="preloader-inner-line"></span><span
                            class="preloader-inner-line"></span><span class="preloader-inner-line"></span><span
                            class="preloader-inner-line"></span><span class="preloader-inner-line"></span><span
                            class="preloader-inner-line"></span><span class="preloader-inner-line"></span><span
                            class="preloader-inner-line"></span><span class="preloader-inner-line"></span>
                    </span>
                </div>
                {{/if}}
            
                <div class="block"><br></div>
            
              </div>
            </div>
        `,
        style: /*css*/`
          .page-${this.namespace} .thumbnail-list ul {
            padding: 0;
            margin: 0;
          }
        `,
        data() {
          return {
            title: $this.title,
            reminder: {
              No: '234234',
            },
            priceReport: { Details: [] },
            infiniteLoadLast: false,
            filter: {},
          };
        },
        methods: {
          resetFilter(e) {
            $this.resetFilter(this, e);
          },
          onFilterFieldChange(e) {
            $this.onFilterFieldChange(this, e);
          },
          createNewContainer(e, id?: string) {
            const self: F7ComponentContextExtend = this;
            id = id || self.$(e.target).closest('li').data('id') || 'new';

            $this.rootServices.navigate('/warehouse/goods-container-form/' + id, {
              context: {
                backTitle: $this.title,
                textColorClass: self.textColorClass,
                callback: (data: { case: string, product: WarehouseGoodsContainerModel }) => {
                  console.log(data);
                  self.refresh();
                  $this.updateCache($this.currentState);
                }
              }
            });
          },
          // createNewProduct(e) {
          //   const self: F7ComponentContextExtend = this;

          //   $this.rootServices.navigate('/admin-product/product/new', {
          //     context: {
          //       backTitle: $this.title,
          //       textColorClass: self.textColorClass,
          //       calback: (data: { case: string, product: WarehouseGoodsContainerModel }) => {
          //         console.log(data);
          //       }
          //     }
          //   });
          // },
          chooseOne(e) {
            const self: F7ComponentContextExtend = this;
            const id = self.$(e.target).closest('li').data('id');
            self.$route.context['onChoose'] && self.$route.context['onChoose'](self.productList.find(f => f.Code === id));
          },
          chooseProduct(e) {

          },
          scan2ContainerCode() {
            $this.scan2ContainerCode();
          },
          async refresh(e, done) {

            $this.refresh(this).then(rs => {
              done && done();
            }).catch(err => {
              done && done();
              $this.commonService.showError(err);
            });

            return true;
          },
          async addGoodsPicture(e) {
            console.debug(e);
            const self: F7ComponentContextExtend = this;
            const id = self.$(e.target).closest('.product-item').data('id');
            const oldProduct = self.productList.find(f => f.Code == id);
            if (!oldProduct) {
              console.error('Not found');
            }

            try {

              self.$f7.dialog.create({
                title: 'Hình ảnh sản phẩm',
                text: 'Bạn muốn xem hình hay thêm hình cho sản phẩm ?',
                buttons: [
                  {
                    text: 'Xem hình',
                    onClick: () => {


                      $this.browseAttachment(oldProduct?.Pictures.map(m => ({
                        Id: m.Id,
                        Type: m.Type,
                        DataType: m.MimeType,
                        Ext: m.Extension,
                        Name: oldProduct.Name,
                        Description: oldProduct.Name,
                        DateOfAttach: oldProduct.Created,
                        // File: string;
                        Thumbnail: m.Thumbnail,
                        Url: m.OriginImage,
                        SmallUrl: m.SmallImage,
                        LargeUrl: m.LargeImage,
                        OriginUrl: m.OriginImage,
                      })) as any, oldProduct.FeaturePicture?.Id, (attachment => {
                        console.debug('download index', attachment);
                        if (/image/.test(attachment.Type)) {
                          // $this.currentState.instance.$app.dialog.confirm([attachment.name, attachment.description].filter(f => !!f).join('<br>') || 'Đính kèm', 'Xác nhận tải về', async () => {
                          //   $this.rootServices.saveImageToPhone(attachment.payload.url as string);
                          // });
                          $this.currentState.instance.$app.dialog.create({
                            title: 'Xác nhận tải về',
                            content: 'Đính kèm',
                            buttons: [
                              {
                                text: 'Đóng',
                                color: 'red',
                                close: true,
                              },
                              {
                                text: 'Mở link',
                                onClick: () => {
                                  $this.rootServices.saveImageToPhone(attachment.Url as string);
                                }
                              }
                            ],
                          }).open();
                        } else if (/video/.test(attachment.Type)) {
                          $this.playVideo((attachment.OriginUrl || attachment.Url) as string);
                        } else {
                          $this.rootServices.iab.create((attachment.OriginUrl || attachment.Url) as string, '_system');
                        }
                      })).then(() => {
                        console.log('Photo browser was closed');
                      });
                    }
                  },
                  {
                    text: 'Thêm hình',
                    onClick: async () => {
                      const localFiles = await $this.rootServices.pickFiles();
                      console.debug(localFiles);

                      let image: FileModel = null;
                      if (localFiles[0].dataType === 'url') {
                        image = await $this.rootServices.uploadLocalFile(localFiles[0].url as string);
                      } else {
                        const formData = new FormData();
                        const imgBlob = new Blob([localFiles[0].url], {
                          type: localFiles[0].type
                        });
                        formData.append('file', imgBlob, 'smart-bot-' + Date.now() + '.' + localFiles[0].ext);
                        image = await $this.rootServices.uploadFileData(formData);
                      }
                      console.debug(image);
                      e.target.style.backgroundImage = 'url(' + image.Thumbnail + ')';

                      // const updateProfileResult = await $this.rootServices.apiService.putPromise('/user/users/updateAccount', {}, { Avatar: image.GlobalId, AvatarThumbnail: image.Thumbnail })
                      const pictures = oldProduct.Pictures || [];
                      pictures.push(image);
                      const updateProfileResult = await $this.rootServices.apiService.putPromise('/admin-product/products/' + id, {}, [{ Code: id, FeaturePicture: image, Pictures: pictures }]);
                      console.debug('Update product picture sucess: ', updateProfileResult);
                      $this.commonService.showInfo('Đã thêm hình ảnh cho hàng hóa: ' + oldProduct.Name);

                      // Update auth user
                      const oldUser = $this.rootServices.authService.user$.getValue();
                      oldUser.avatar = oldUser.avatar || { id: '', payload: {} };
                      oldUser.avatar = { ...oldUser.avatar, payload: { ...oldUser.avatar.payload, thumbnail: image.Thumbnail, url: image.DownloadLink } }
                      $this.rootServices.authService.user$.next(oldUser);

                    }
                  },
                  {
                    text: 'Trở về',
                  },
                ],
                verticalButtons: true,
              }).open();


            } catch (err) {
              console.error(err);
              $this.commonService.showError(err);
            }

          },
        },
        on: {
          // pageMounted(e, page) {
          //     console.log('page mounted');
          // },
          pageInit(e, page: F7Page) {
            console.log('page init');
            const self: F7ComponentContextExtend = this;

            self.calendarDateTime = self.$f7.calendar.create({
              // openIn: 'customModal',
              inputEl: page.$el.find('input[name="RemindAtDateTime"]'),
              timePicker: true,
              dateFormat: { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' },
              // header: true,
              footer: true,
            });

            $this.onComponentInit({ instance: self }, self.$route?.params?.action || 'main', null, page);

            $this.rootServices.authService.isAuthenticatedOrRefresh().pipe(take(1)).toPromise().then(() => {
              self.$setState({
                backTitle: self.$route.context && self.$route.context.backTitle || 'Back', title: self.$route.context && self.$route.context.title || 'Profile',
              });

            }).catch(err => {
              console.error(err);
              $this.commonService.showError(err);
            });

          },
          // pageBeforeIn(e, page) {
          //     console.log('page before in');
          //     const self: F7ComponentContextExtend = this;
          //     self.refresh();
          // },
          // pageAfterIn(e, page) {
          //     console.log('page after in');
          // },
          pageBeforeOut(e, page) {
            const self: F7ComponentContextExtend = this;
            console.log('page before out');
            $this.onBeforeChangedState({ instance: self, page, scrollPosition: $(page.el).find('.page-content').scrollTop() }, self.componentIndex);
          },
          // pageAfterOut(e, page) {
          //     console.log('page after out');
          // },
          // pageBeforeUnmount(e, page) {
          //     console.log('page before unmount');
          // },
          // pageBeforeRemove(e, page) {
          //     console.log('page before remove');
          // },
          pageBeforeRemove(e, page) {
            console.log('[page event] before remove', page.route.url);
            const self: F7ComponentContextExtend = this;
            // const starmtSelectRoles = self.$app.smartSelect.get('.smart-select');
            // starmtSelectRoles.destroy();
          },
        },
      },
    };
  }
}
